import {
  createAttachmentHooks,
  type AttachmentAction,
  uploadFile,
  uploadFileToS3,
} from '@markku/components'
import { trpc } from '../trpc'

// Re-export utility functions
export { uploadFile, uploadFileToS3 }

// Re-export type
export type { AttachmentAction }

// Create typed attachment hooks for this app
export const attachmentHooks = createAttachmentHooks(trpc)
